/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
export const allowedByOpop = (access_object) => {
    console.log("secure check :: accessObject", access_object)
    let user_privileges = JSON.parse(sessionStorage.getItem('user_privileges'))

    if (user_privileges.length === 0) {
        return false
    }

    if (access_object) {
        let operation_exists = operationExists(user_privileges, access_object)
        if (access_object.operands.length === 0) {
            if (operation_exists) {
                console.log("secure check :: allowed")
                return true
            } else {
                console.log("secure check :: Denied")
                return false
            }
        } else {
            if (operation_exists) {
                let privilege_object = getUserPrivilegeObject(user_privileges, access_object)
                console.log("secure check :: privilege_object", privilege_object)
                if (operandsAllowed(privilege_object, access_object)) {
                    console.log("secure check :: allowed")
                    return true
                } else {
                    console.log("secure check :: Denied")
                    return false
                }
            } else {    
                console.log("secure check :: Denied")   
                return false
            }
        }
    } else {
        console.log("secure check :: Denied")
        return false
    }
}

const operationExists = (user_privileges, access_object) => {
    let operation_index = user_privileges.findIndex((opop_object) => access_object.operation === opop_object.operation && access_object.method === opop_object.method)

    if (operation_index === -1) {
        return false
    } else {
        console.log("secure check :: Operation_index",operation_index)
        return true
    }
}

const getUserPrivilegeObject = (user_privileges, access_object) => {
    let operation_index = user_privileges.findIndex((opop_object) => access_object.operation === opop_object.operation && access_object.method === opop_object.method)
    return user_privileges[operation_index]
}

const operandsAllowed = (privilege_object, access_object) => {
    let operand_permissions_list = []

    access_object.operands.map(operand => {
        let privilege_operand = privilege_object.operands.find(op => op.attrName === operand.attrName)
        if (privilege_operand) {
            if (privilege_operand.instances.includes('All')) {
                operand_permissions_list.push(true)
            } else if (privilege_operand.instances.includes(operand.value)) {
                operand_permissions_list.push(true)
            } else {
                operand_permissions_list.push(false)
            }
        } else {
            operand_permissions_list.push(false)
        }
    })
    console.log("secure check :: Operand_permission_List",operand_permissions_list)
    if (operand_permissions_list.filter(perm => perm === false).length > 0) {
        return false
    } else {
        return true
    }
}